import React, { useCallback, } from 'react';
import { connect, } from 'react-redux';
import { useHistory, } from 'react-router-dom';
import Box from '@material-ui/core/Box';

import { StoreBasicDataApiStructure, } from 'common/types';
import { repositories, } from 'api';
import { productsOperations, } from 'store/ducks/products/collection';
import { isAnySelectedSelector, } from 'store/ducks/products/collection/selectors';
import { ProductsFilterStore, } from 'store/ducks/products/collection/types';
import { primaryBackgroundButtonColor, }  from 'styles/abstract/variables';
import { utils, } from 'styles';

type Props = {
    currentItemsAmount: number,
    filtered?: number,
    total: number,
    isAnySelected: boolean,
    fetchProducts: Function,
};

const ProductsFilterBar: React.FC<Props> = ({
    isAnySelected,
    fetchProducts,
    filtered,
    total,
}) => {
    const history = useHistory();
    const pointerStyles = utils.makePointerStyles();

    const removeAllFilters = useCallback(() => {
        fetchProducts();
        history.push({ search: '', });
    }, [ fetchProducts, history, ]);

    if (!isAnySelected || total <= 0) {
        return null;
    }

    return (
        <div>
            Wyszukanych pozycji {filtered} z {total} <Box color={primaryBackgroundButtonColor}
                                                       component="span"
                                                       onClick={removeAllFilters}
                                                       className={pointerStyles.root}>
                (usuń wszystkie filtry)
            </Box>
        </div>
    );
};

type MappingType = {
    products: {
        collection: StoreBasicDataApiStructure<repositories.products.CollectionTypes.ProductsType> & ProductsFilterStore,
    },
};

const mapStateToProps = ({ products }: MappingType) => ({
    currentItemsAmount: products.collection.data?.items?.length || 0,
    total: products.collection.data?.total,
    filtered: products.collection.data?.filtered,
    isAnySelected: isAnySelectedSelector(products),
});

const mapDispatchToProps = {
    fetchProducts: productsOperations.request,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductsFilterBar);
